import { FunctionComponent } from 'react'
import type { CmsPageProps } from '../../components/page'
import { useGetCurrentUser } from '../hooks/user'
import { CurrentUserContextProvider } from '../services/user/context'

export const withCurrentUser = <T extends CmsPageProps>(Component: FunctionComponent<T>): FunctionComponent<T> => {
  return (pageProps) => {
    const currentUser = useGetCurrentUser()

    return (
      <CurrentUserContextProvider value={currentUser}>
        <Component {...pageProps} />
      </CurrentUserContextProvider>
    )
  }
}
